/**
 * Whether a candidate's current employer is shown as confirmed by that employer.
 *
 * The server records the employer's answer and writes it into metadata, which the candidate cannot
 * write; nothing in public data counts. A confirmation counts only for the employer the profile names
 * now, compared by the same key the server uses: the company listing when there is one, else the
 * name.
 */

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const employerKeyOfCompany = company => {
  if (!company || typeof company !== 'object') return '';
  if (typeof company.listingId === 'string' && UUID_PATTERN.test(company.listingId)) return company.listingId;
  const label = typeof company.label === 'string' ? company.label.trim().toLowerCase() : '';
  return label ? `name:${label}` : '';
};

// The recorded confirmation on a listing or a user, from metadata only.
export const confirmationOf = entity =>
  entity?.attributes?.metadata?.currentEmployerConfirmation ||
  entity?.attributes?.profile?.metadata?.currentEmployerConfirmation ||
  undefined;

// 'confirmed' or 'unconfirmed' for the current employer a profile names.
export const currentEmployerConfirmationState = (currentEmployer, confirmation) => {
  const key = employerKeyOfCompany(currentEmployer?.company);
  return key && confirmation?.status === 'confirmed' && confirmation.employerKey === key ? 'confirmed' : 'unconfirmed';
};
